import React from 'react'
import { ColumnMappingEnum, Direction } from 'api'
import { Locale, Translation } from 'locale'
import { DirectionHelper } from 'model'
import { ComboboxField, DropdownListbox } from 'view/components/options'
import { LabelPosition } from 'view/styles/constants'
import { getAllHeadings, DeriveDirection } from '../model'
import { ColumnMappingPanelProps, ColumnMappingPanel } from './ColumnMappingPanel'
import { DropdownTitle } from 'view/components/options/optionsStyles'
import { EnumValuesPanel } from './EnumValuesPanel'

export const ColumnMappingDirectionPanel: React.FunctionComponent<ColumnMappingPanelProps<ColumnMappingEnum<Direction>>> = props => {
  const { fieldTitle, fieldName, columnMapping, parseResult, onUpdate } = props

  const handleUpdateHeading = (heading: string) => onUpdate({ ...columnMapping, heading }, fieldName)

  const handleUpdateValues = (values: { [index: string]: string }) => onUpdate({ ...columnMapping, values }, fieldName)

  const notionalDropdown = (
    <DropdownListbox
      title={<DropdownTitle>{Locale.translate(Translation.SC_DERIVE_FROM_AMOUNTS)}</DropdownTitle>}
      optionKeys={[DeriveDirection.PositiveIsBuy, DeriveDirection.PositiveIsSell]}
      getOptionText={getDeriveDirectionName}
      onUpdate={handleUpdateHeading}
    />
  )

  return (
    <ColumnMappingPanel>
      <ComboboxField
        label={fieldTitle}
        labelPosition={LabelPosition.Left}
        optionKeys={getAllHeadings(parseResult.rows)}
        value={columnMapping.heading}
        validationField={fieldTitle}
        validationIssues={parseResult.issues}
        canClear={true}
        secondaryDropdown={notionalDropdown}
        onUpdate={handleUpdateHeading}
      />
      <EnumValuesPanel
        Enum={Direction}
        enumHelper={DirectionHelper}
        disabled={columnMapping.heading === DeriveDirection.PositiveIsBuy || columnMapping.heading === DeriveDirection.PositiveIsSell}
        values={columnMapping.values}
        onUpdate={handleUpdateValues}
      />
    </ColumnMappingPanel>
  )
}

function getDeriveDirectionName(deriveDirection: DeriveDirection) {
  switch (deriveDirection) {
    case DeriveDirection.PositiveIsBuy:
      return Locale.translate(Translation.SC_POSITIVE_IS_BUY)

    case DeriveDirection.PositiveIsSell:
      return Locale.translate(Translation.SC_POSITIVE_IS_SELL)

    default:
      throw new Error(`Unhandled DeriveDirection ${[deriveDirection]}`)
  }
}
